import { Box, Dialog, DialogActions, DialogContent, Icon } from '@mui/material';
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import CDialogHeader from '../../../components/modal/CDialogHeader';
import { CButton } from '../../../components/StyledComponent';
import ControlledTextField from '../../../components/controlled_component/ControlledTextField';
import ControlledNumTextField from '../../../components/controlled_component/ControlledNumTextField';
import { getPriceReqDetail, updatePriceReqStatus } from '../../../controller/mbg/mgbPriceReqController';
import { toast } from 'react-toastify';
import Loading from '../../../components/Loading';

const formState = yup.object({
    margin_price: yup.number()
        .transform((value, originalValue) => {
            // Convert "" to NaN so Yup treats it as empty
            return originalValue === "" ? NaN : value;
        })
        .typeError("nominal tidak boleh kosong") // if not a number or NaN
        .required("nominal tidak boleh kosong"), // if empty or missing,
})
const defaultValues = async ({ id }) => {
    const apiList = [getPriceReqDetail(id)]
    const [detail] = await Promise.all(apiList)
    return { ...detail }
}
function MBGNotifPriceApprove({ open = false, data = undefined, onSubmit, onClose }) {
    const { t } = useTranslation()
    const title = t(`Terima perubahan harga`)

    const formMethod = useForm({
        resolver: yupResolver(formState),
        defaultValues: async () => await defaultValues(data)
    })
    const { control, handleSubmit, reset } = formMethod
    const { isLoading, isSubmitting } = formMethod.formState

    const _onClose = () => { onClose(); reset(); }
    const _onSubmit = async ({ id, margin_price }) => {
        const postData = { id, status: 'approve', margin_price }
        const { code } = await updatePriceReqStatus(postData)
        const textMsg = `membuat permintaan`

        const successFlag = code === 200
        if (!successFlag) return toast.error(`Gagal ${textMsg}`)
        toast.success(`Berhasil ${textMsg}`)
        if (onSubmit) onSubmit()
    }

    return (
        <Dialog open={open}>
            <CDialogHeader title={title} onClose={_onClose} disabled={isSubmitting} />
            <Box component={'form'} sx={{ minWidth: '400px', minHeight: '200px' }} onSubmit={handleSubmit(_onSubmit)}>
                {isLoading && <Loading />}
                {!isLoading && (
                    <>
                        <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', padding: '0.5rem' }}>
                            <ControlledTextField control={control} name={'name'} label={t('common.name')} disabled={true} />
                            <ControlledTextField control={control} name={'sku'} label={t('common.sku')} disabled={true} />
                            <ControlledNumTextField control={control} label={t(`Harga Jual Lama`)}
                                name={'selling_price'} disabled={true}
                            />
                            <ControlledNumTextField control={control} label={t(`Harga Jual Baru`)}
                                name={'new_selling_price'} disabled={true}
                            />
                            <ControlledNumTextField control={control} label={t(`Nominal Margin`)}
                                name={'margin_price'} allowEmpty={true}
                                disabled={isSubmitting}
                            />
                        </DialogContent>
                        <DialogActions>
                            <CButton type='submit' startIcon={<Icon>done</Icon>} disabled={isSubmitting}>
                                {t(`common.${isSubmitting ? 'loading' : 'approve'}`)}
                            </CButton>
                        </DialogActions>
                    </>
                )}
            </Box>
        </Dialog>
    );
}

export default MBGNotifPriceApprove;